import Vuex from 'vuex';
import Vue from 'vue';
import { queryAccountInfo } from '../service/getData';
import { baiduReport } from '../js/common';

Vue.use(Vuex);

let businessNo = 'xubei_m';
if (sessionStorage.getItem('businessNo')) {
 businessNo = sessionStorage.getItem('businessNo')
} else if (window.location.href.indexOf('xubei.org') > -1) {
	businessNo = 'xubei_h5org';
} else if (window.location.href.indexOf('zh.ugpaly.com') > -1) {
	businessNo = 'xubei_tfugpaly';
} else if (window.location.href.indexOf('zhw.whysjiaoyu.cn') > -1) {
	businessNo = 'xubei_whysjiaoyu';
} else if (window.location.href.indexOf('zhw.yunijy.com') > -1) {
	businessNo = 'xubei_mtfyunijy';
} else if (window.location.href.indexOf('xunyou.xubei.com') > -1) {
	businessNo = 'xunyou_h5';
}

export const store = new Vuex.Store({
	state: {
		userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}, // 用户信息
		selectedGame: [], // 选中的游戏信息
		weipayBusinessNo: '', // 公用微信支付的渠道号
		userData: {},
		encrypt: {},
		filterCriteria: {},
		businessNo: businessNo,
		channel: sessionStorage.getItem('channel') || '',
		virtualChannel: sessionStorage.getItem('virtualChannel') || ''
	},
	actions: {
		getUserData({ commit }) {
			return queryAccountInfo()
				.then((res) => {
					if (res.data.code == 1) {
						commit('setUserData', res.data.result);
						return Promise.resolve();
					}
					return Promise.reject(res.data);
				})
				.catch((err) => {
					return Promise.reject(err);
				});
		},
		updateFilterCriteria({ commit }, data) {
			commit('setFilterCriteria', data);
		},
		resetFilterCriteria({ commit }) {
			commit('clearFilterCriteria');
		}
	},
	mutations: {
		setBusinessNo(state, data) {
			state.businessNo = data;
		},
		setChannel(state, data) {
			state.channel = data;
		},
		setVirtualChannel(state, data) {
			state.virtualChannel = data;
		},
		setUserData(state, data) {
			state.userData = data;
		},
		setUserInfo(state, data) {
			state.userInfo = data;
			// if (!!data.newUser) {
			// 	// 注册用户则上报百度
			// 	baiduReport({
			// 		newType: 3,
			// 		mobile: data.mobile
			// 	});
			// }
			localStorage.setItem('userInfo', JSON.stringify(data));
		},
		setUserEncrypt(state, data) {
			state.encrypt = data;
			localStorage.setItem('encrypt', JSON.stringify(data));
		},
		setSelectedGame(state, data) {
			state.selectedGame = data;
			localStorage.setItem('selectedGame', JSON.stringify(data));
		},
		setWeipayBusinessNo(state, data) {
			state.weipayBusinessNo = data;
		},
		setFilterCriteria(state, data) {
			state.filterCriteria = data;
			// sessionStorage.setItem("filterCriteria", JSON.stringify(data));
		},
		clearFilterCriteria(state) {
			state.filterCriteria = {};
		}
	}
});



// WEBPACK FOOTER //
// ./src/store/store.js